import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Divider } from "@mui/material";
import { ExportAgentPDFButton } from "./exportAgentPDF";
import { useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import {
  BusinessOutlined,
  PublicOutlined,
  AccountBalanceOutlined,
  AttachFileOutlined,
  LocalShippingOutlined,
} from "@mui/icons-material";
import { getRoleFromStorage } from "../../utils/auth";
import ActionButtons from "./ActionButtons";
import { api_path } from "../../shared.js";
import { updateStatus } from "../../utils/UpdateStatus.js";
import {
  PageHeader,
  SectionCard,
  FieldItem,
  MetricCard,
  TagList,
  FileGroup,
} from "./RegistrationShared";

export default function AgentRegisterDetailView(props) {
  const [searchParams] = useSearchParams();
  const job_id = searchParams.get("id");
  const ROLE = getRoleFromStorage();

  const [form, setForm] = useState({});
  const [files, setFiles] = useState({});
  const [approvalStatus, setApprovalStatus] = useState(null);

  useEffect(() => {
    if (job_id) fetchData();
  }, [job_id]);

  const fetchData = async () => {
    const res = await fetch(`${api_path}/customer/get-AgentRegistration.php?id=${job_id}`);
    const result = await res.json();
    const data = result.data;
    setForm(data);
    setApprovalStatus(data.approval_status);
    setFiles(result.files || {});
  };

  const show = (value) => {
    if (value === true) return "Yes";
    if (value === false) return "No";
    if (Array.isArray(value)) return value.join(", ");
    return value || "–";
  };


  const onSubmitForm = React.useCallback(({ STATUS }) => {

    console.log("props.UserID:", props.UserID);
    console.log("localStorage USER_ID:", localStorage.getItem("USER_ID"));

    swal({ title: "Are you sure to send data?", icon: "info", dangerMode: false, buttons: true })
      .then((isConfirm) => {
        if (isConfirm) {
          updateStatus({ JOB_ID: job_id, JOB_TYPE: "AGENT", STATUS, REMARK: "", REASON_ID: "", REASON_NAME: "", USER_ID: props.UserID || JSON.parse(localStorage.getItem("USER_ID")) });
        }
      });
  }, [job_id, props.UserID]);

  const onEditButtonClick = React.useCallback((e) => {
    window.open(`/s-crm/CustomerRegisterForm?id=${e.row.key}&type=${e.row?.data?.SourceID}`, "_blank");
  }, []);

  const profileTypes = [
    form?.profileType?.agent && "Agent",
    form?.profileType?.consignee && "Consignee",
    form?.profileType?.notify && "Notify",
    form?.profileType?.shipper && "Shipper",
  ].filter(Boolean);

  const businessTypes = [
    form?.businessType?.seaExport && "Sea Export",
    form?.businessType?.seaImport && "Sea Import",
    form?.businessType?.airExport && "Air Export",
    form?.businessType?.airImport && "Air Import",
    form?.businessType?.other && "Other",
  ].filter(Boolean);

  const alliances = [
    form?.alliance?.WCA && "WCA",
    form?.alliance?.PPL && "PPL",
    form?.alliance?.X2 && "X2",
    form?.alliance?.other && "Other",
    form?.alliance?.membership && "Membership",
  ].filter(Boolean);

  const hasFiles = files.COMPANY_PROFILE?.length || files.AGENCY_AGREEMENT?.length;
  const formatNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(String(value).replace(/,/g, ""));
    if (isNaN(num)) return value; // ถ้าไม่ใช่ตัวเลขจริง ๆ ให้คืนค่าเดิม
    return num.toLocaleString("en-US", { maximumFractionDigits: 2 });
  };
  return (
    <Box sx={{ p: 3, maxWidth: 900 }}>
      <PageHeader
        title="Agent/Consignee Registration Details"
        createBy={form.create_by}
        date={form.createDate}
        approvalStatus={approvalStatus}
        statusName={form.status_name}
      />


      <SectionCard icon={<BusinessOutlined fontSize="small" />} title="Request Information">
        <Grid container spacing={2}>
          <FieldItem label="Code No" value={form?.requestInfo?.codeNo} />
          <FieldItem label="Date" value={form?.requestInfo?.date} />
          <FieldItem label="Regions" value={show(form?.regions)} />
          <Grid item xs={12}>
            <Typography
              component="span"
              variant="caption"
              sx={{ color: "text.secondary", textTransform: "uppercase", letterSpacing: "0.05em", fontWeight: 600, fontSize: "0.7rem", display: "block", mb: 0.75 }}
            >
              Profile Type
            </Typography>
            <TagList items={profileTypes} />
          </Grid>
        </Grid>
      </SectionCard>

      <SectionCard icon={<BusinessOutlined fontSize="small" />} title="Basic Information">
        <Grid container spacing={2}>
          <FieldItem label="Agent/Consignee Name" value={form?.basicInfo?.name} xs={12} />
          <FieldItem label="Address" value={form?.basicInfo?.address} xs={12} />
          <FieldItem label="District" value={form?.basicInfo?.district} />
          <FieldItem label="Sub-district" value={form?.basicInfo?.subdistrict} />
          <FieldItem label="City" value={form?.basicInfo?.city} />
          <FieldItem label="Postal Code" value={form?.basicInfo?.postalCode} />
          <FieldItem label="Country" value={form?.basicInfo?.country} />
          <FieldItem label="Email" value={form?.basicInfo?.email} />
          <FieldItem label="Tel" value={form?.basicInfo?.tel} />
          <FieldItem label="Contact Person" value={form?.basicInfo?.contactPerson} />
        </Grid>
      </SectionCard>

      <SectionCard icon={<LocalShippingOutlined fontSize="small" />} title="Type of Business">
        <TagList items={businessTypes} />
      </SectionCard>

      <SectionCard icon={<PublicOutlined fontSize="small" />} title="Global Alliance / Network">
        <TagList items={alliances} />
      </SectionCard>

      <SectionCard icon={<AccountBalanceOutlined fontSize="small" />} title="Financial">
        <Grid container spacing={1.5}>
          <Grid item xs={6} sm={4}>
            <MetricCard label="Credit Term" value={form?.financial?.creditTerm} unit="Days" />
          </Grid>
          <Grid item xs={6} sm={4}>
            <MetricCard label="Credit Limit" value={formatNumber(form?.financial?.creditLimit)} unit="USD" />
          </Grid>
          <Grid item xs={6} sm={4}>
            <MetricCard label="Type" value={form?.financial?.type} />
          </Grid>
        </Grid>
      </SectionCard>

      {hasFiles && (
        <SectionCard icon={<AttachFileOutlined fontSize="small" />} title="Documents">
          <FileGroup label="Company Profile" files={files.COMPANY_PROFILE} />
          <FileGroup label="Agency Agreement" files={files.AGENCY_AGREEMENT} />
        </SectionCard>
      )}
  <ExportAgentPDFButton form={form} files={files} />
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <ActionButtons ID={job_id} TYPE="AGENT" ROLE={ROLE} STATUS={approvalStatus} onEdit={onEditButtonClick} onSubmit={onSubmitForm} />
      </Box>
    </Box>
  );
}
